<script>
export default {};
</script>

<style></style>
<script>
import { mapGetters } from "vuex";
import store from "@/shared/store";
export default {
  name: "BaseComponent",
  computed: {
    ...mapGetters(["isGranted", "isAnyGranted"])
  }
};
</script>
